import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
import { DatePipe } from '@angular/common';
declare var google: any;

@Component({
  selector: 'app-sale-campaign-edit-modal',
  templateUrl: './sale-campaign-edit-modal.component.html',
  styleUrls: ['./sale-campaign-edit-modal.component.scss'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class SaleCampaignEditModalComponent implements OnInit {

  authToken = localStorage.getItem("token")
  public authInfo = JSON.parse(localStorage.getItem("authInfo"));

  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  isSuperAdmin: boolean = this.userInfo.admin;


  btnStatus: boolean = false
  project: any = {}
  createProjectForm: FormGroup;
  isSubmit: boolean = false;

  emails: any[] = []
  clients: any[] = []

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  project_delivery_date: any;

  mapView: boolean = true
  @ViewChild("mapContainer", { static: false }) gmap: ElementRef;
  map: any
  latLng: any
  geocoder: any;
  marker: any;
  infowindow: any

  address: any = ""

  latitude: any = '20.5937'
  longitude: any = '78.9629'
  latLngCoords: boolean = false
  dropdownSettingsClient = {};
  selectedClient = '';

  salePersonList: any;
  mmList: any;
  showComponentLoader: boolean = true;

  isShowBrochure: boolean = false;
  isShowRera: boolean = false;

  isMODChecked: boolean = false;
  isAurumMODChecked: boolean = false;
  isSheetMODChecked: boolean = false;
  isCRMMODChecked: boolean = false;
  isOtherMODChecked: boolean = false;

  isNotificationChecked: boolean = false;
  isMailChecked: boolean = false;
  isSMSChecked: boolean = false;

  brochureTobeUpload = [];
  creativeTobeUpload = [];
  mediaPlanTobeUpload = [];

  getTypologyLenght: any;
  typologyArr: any;
  typologyInnerObj = {};

  getCommonDetail: any;

  vendorList: any;

  minValuesWithComma: any = '';
  minValuesWithCommaSystem: any;
  minNumInWords: any = '';

  maxValuesWithComma: any = '';
  maxValuesWithCommaSystem: any;
  maxNumInWords: any = '';

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SaleCampaignEditModalComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) private data
  ) {

    this.setEdit()

    //console.log(data)

    if (data.topology != null && JSON.parse(data.topology).length) {
      this.getTypologyLenght = data.topology.length
    }

    this.createProjectForm.controls.sp.patchValue(data.sales_manager_id)
   
    this.createProjectForm.controls.st.patchValue(data.sales_city)
    this.createProjectForm.controls.am.patchValue(data.account_manager_id)
    this.createProjectForm.controls.clientType.patchValue(data.client_type)

    this.createProjectForm.controls.clientName.patchValue(data.client_name)
    this.createProjectForm.controls.clientMobileNumber.patchValue(data.client_number)
    this.createProjectForm.controls.clientEmail.patchValue(data.client_email)
    this.createProjectForm.controls.city.patchValue(data.city)
    this.createProjectForm.controls.clientRera.patchValue(data.client_rera)
    this.createProjectForm.controls.accountType.patchValue(data.account_type)

    if (this.isSuperAdmin) {
      this.createProjectForm.controls.vendor.patchValue(data.vendor)
    }

    this.createProjectForm.controls.invoiceEstimateId.patchValue(data.estimated_invoice_id)
    this.createProjectForm.controls.dealType.patchValue(data.deal_type)

    this.createProjectForm.controls.projectName.patchValue(data.project_name)
    this.createProjectForm.controls.projectType.patchValue(data.project_type)
    this.createProjectForm.controls.location.patchValue(data.project_address)
    this.createProjectForm.controls.latitude.patchValue(data.latitude)
    this.createProjectForm.controls.longitude.patchValue(data.longitude)

    if (data.latitude != null && data.longitude != null) {
      this.latLngCoords = true
      this.latitude = data.latitude
      this.longitude = data.longitude
    }


    this.createProjectForm.controls.minPrice.patchValue(data.min_price)
    this.createProjectForm.controls.maxPrice.patchValue(data.max_price)

  
    if(data.min_price){
      this.valueInWords(data.min_price, 'minValue')
    }
    if(data.max_price){
      this.valueInWords(data.max_price, 'maxValue')
    }
    

    this.createProjectForm.controls.configuration.patchValue(data.project_configuration)
    this.createProjectForm.controls.projectStatus.patchValue(data.project_status)


    this.checkProjectStatus(data.project_status)

    if (data.project_status == "Ready to move In") {
      this.isShowRera = false;
      this.isShowBrochure = true;
    } else if (data.project_status == "Under Construction") {
      this.isShowRera = true;
      this.isShowBrochure = true;
    } else if (data.project_status == "Pre Launch") {
      this.isShowRera = false;
      this.isShowBrochure = false;
    }

    if (data.topology != null && JSON.parse(data.topology).length) {

      for (const item of JSON.parse(data.topology)) {
        this.arrTypologyForm.push(this.setTypologyForm())
      }

      this.createProjectForm.controls.typology.patchValue(JSON.parse(data.topology));

    } else {
      this.arrTypologyForm.push(this.setTypologyForm())
    }

    //   this.createProjectForm.controls.typology.patchValue([
    //     {
    //         typologyConfiguration: "1-BHK",
    //         typologyPrice: "100000"
    //     },
    //     {
    //         typologyConfiguration: "2-BHK",
    //         typologyPrice: "200000"
    //     }
    // ]);


    if (data.brochure != null) {
      this.brochureTobeUpload = data.brochure
    }
    //this.createProjectForm.controls.uploadBrochure.patchValue('')    

    const dateStr = data.possession;
    const formattedDate = this.datePipe.transform(dateStr, 'yyyy-MM-dd');
    //console.log(formattedDate);
    this.createProjectForm.controls.possession.patchValue(formattedDate)

    this.createProjectForm.controls.reraId.patchValue(data.rera_number)

    this.createProjectForm.controls.campaignType.patchValue(data.campaign_type)
    this.createProjectForm.controls.duration.patchValue(data.duration)
    this.createProjectForm.controls.noOfLeads.patchValue(data.no_of_leads)
    this.createProjectForm.controls.minQua.patchValue(data.min_committed_qualification)
    this.createProjectForm.controls.maxQua.patchValue(data.max_committed_qualification)


    //let modArr = data.mode_of_delivery.split(',')

    let modArr = JSON.parse(data.mode_of_delivery)
    let modAurum: boolean = false
    let modSheet: boolean = false
    let modCRM: boolean = false
    let modOther: boolean = false

    modArr.includes('Automate Leads') ? modAurum = true : modAurum = false
    modArr.includes('CRM') ? modCRM = true : modCRM = false
    modArr.includes('Google Sheet') ? modSheet = true : modSheet = false
    modArr.includes('Other') ? modOther = true : modOther = false

    if (modAurum || modCRM || modSheet || modOther) {
      this.isMODChecked = true
    } else {
      this.isMODChecked = false
    }

    this.createProjectForm.controls.modAurum.patchValue(modAurum)
    this.createProjectForm.controls.modSheet.patchValue(modSheet)
    this.createProjectForm.controls.modCRM.patchValue(modCRM)
    this.createProjectForm.controls.modOther.patchValue(modOther)

    //let monArr = data.mode_of_notification.split(',')
    let monArr = JSON.parse(data.mode_of_notification)
    let monMail: boolean = false
    let monSMS: boolean = false
    let monNA: boolean = false
    monArr.includes('Email') ? monMail = true : monMail = false
    monArr.includes('SMS') ? monSMS = true : monSMS = false

    if (monMail || monMail) {
      this.isNotificationChecked = true
    } else {
      this.isNotificationChecked = false
    }


    this.createProjectForm.controls.mailNotification.patchValue(monMail)
    this.createProjectForm.controls.smsNotification.patchValue(monSMS)

    this.createProjectForm.controls.offers.patchValue(data.offers)
    this.createProjectForm.controls.creativeLink.patchValue(data.media_plan)

    if (data.creative_attachment != null) {
      this.creativeTobeUpload = data.creative_attachment
    }

    if (data.media_plan_attachment != null) {
      this.mediaPlanTobeUpload = data.media_plan_attachment

    }

    //this.checkMOD()
    //this.checkNotification()
  }

  ngOnInit() {

    this.dropdownSettingsClient = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true
    };

    this.getSP()
    this.getMM()
    this.getCampaingCommonDetail()
    this.getVendor()

  }

  ngAfterViewInit() {
    this.mapInitializer();
  }

  setEdit() {
    this.createProjectForm = this.fb.group({
      sp: [, Validators.required],
      msp: [],
      st: [, Validators.required],
      am: [],
      clientType: [null, Validators.required],
      clientName: ["", Validators.required],
      clientMobileNumber: ["", Validators.required],
      clientEmail: ["", [Validators.required, Validators.email]],
      city: ["", Validators.required],
      clientRera: [""],
      accountType: ["", Validators.required],
      vendor: [""],

      invoiceEstimateId: ["", Validators.required],
      dealType: ["", Validators.required],

      projectName: ["", Validators.required],
      projectType: ["", Validators.required],
      location: ["", Validators.required],
      latitude: ["",Validators.required],
      longitude: ["",Validators.required],
      minPrice: ["", Validators.required],
      maxPrice: [""],
      configuration: ["", Validators.required],
      projectStatus: ["", Validators.required],

      //typology: this.fb.array([this.setTypologyForm()]),
      typology: this.fb.array([]),

      uploadBrochure: [""],
      possession: [""],
      reraId: [""],

      campaignType: ["", Validators.required],
      duration: ["", Validators.required],
      noOfLeads: ["", Validators.required],
      minQua: ["", Validators.required],
      maxQua: ["", Validators.required],

      modAurum: [true],
      modSheet: [false],
      modCRM: [false],
      modOther: [false],

      mailNotification: [true],
      smsNotification: [false],

      offers: ["", Validators.required],
      creativeLink: ["", Validators.required],

      uploadCreativesOpenFiles: [""],
      uploadMediaPlan: [""]

    })
  }

  get fCreate() {
    return this.createProjectForm.controls;
  }

  setTypologyForm() {
    return this.fb.group({
      typologyConfiguration: [''],
      typologyPrice: ['']
    })
  }

  get arrTypologyForm(): FormArray {
    return this.createProjectForm.get("typology") as FormArray;
  }

  addRow() {
    this.arrTypologyForm.push(this.setTypologyForm());
  }

  removeRow(i) {
    if (this.arrTypologyForm.length > 1) {
      this.arrTypologyForm.removeAt(i);
    }
  }

  // google map

  mapInitializer() {
    this.geocoder = new google.maps.Geocoder();
    this.latLng = new google.maps.LatLng(this.latitude, this.longitude);
    this.infowindow = new google.maps.InfoWindow();
    let mapOptions = {
      center: this.latLng,
      zoom: 6,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.marker = new google.maps.Marker({
      position: this.latLng,
      map: this.map
    });
    setTimeout(() => {
      this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
      this.marker.setMap(this.map);
    })
  }

  locateAddressOnMap() {
    if (this.createProjectForm.value.location != '') {
      this.map.setZoom(15);
      this.address = this.createProjectForm.value.location;
      this.findLocation(this.address);
    }
  }

  findLocation(address: string) {
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    this.geocoder.geocode({ address: address }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        this.marker = new google.maps.Marker({
          position: results[0].geometry.location,
          map: this.map,
          draggable: true
        });
        this.map.setCenter(results[0].geometry.location);
        this.infowindow.setContent(results[0].formatted_address);
        this.infowindow.open(this.map, this.marker);
        this.latitude = results[0].geometry.location.lat();

        this.longitude = results[0].geometry.location.lng();
        this.createProjectForm.get('latitude').patchValue(this.latitude)
        this.createProjectForm.get('longitude').patchValue(this.longitude)
        this.latLngCoords = true;
        this.marker.addListener("dragend", event => {
          this.latitude = event.latLng.lat();
          this.longitude = event.latLng.lng();
        });
        this.createProjectForm.controls.latitude.patchValue(this.latitude)
        this.createProjectForm.controls.longitude.patchValue(this.longitude)
      } else {
        this.createProjectForm.controls.latitude.patchValue("")
        this.createProjectForm.controls.longitude.patchValue("")
        this.clipBoardService.showMessgeInText("Sorry, this search produced no results", "error-snackbar")
        this.latLngCoords = false;
      }
    });
  }

  clearMap() {
    this.createProjectForm.controls.location.patchValue('')
    this.createProjectForm.controls.latitude.patchValue('')
    this.createProjectForm.controls.longitude.patchValue('')
    this.latitude = '20.5937'
    this.longitude = '78.9629'
    this.latLngCoords = false
    this.mapInitializer()
  }

  // google map end

  getSP() {

    this.showComponentLoader = true
    let url = "/campaign_module/user_list?user_type=SalesAdmin";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.salePersonList = data.data
      if(this.data.assigned_sales_user_id){
      const selectedIds = this.data.assigned_sales_user_id.split(',').map(id => parseInt(id, 10));
      this.createProjectForm.get('msp').setValue(selectedIds);
      }
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getMM() {

    this.showComponentLoader = true

    let url = "/campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.mmList = data.data
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getVendor() {
    this.showComponentLoader = true
    this.serverService.vendorsList(this.authToken).subscribe(data => {
      this.vendorList = data
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getCampaingCommonDetail() {

    this.showComponentLoader = true

    this.serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      this.getCommonDetail = data
      //console.log(this.getCommonDetail)
      this.showComponentLoader = false
    }, err => {
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
    });
  }

  checkProjectStatus(event: any) {
    //console.log(event.value)
    if (event.value == 'Ready to move In') {
      this.isShowRera = false;
      this.isShowBrochure = true;
      this.createProjectForm.controls["possession"].clearValidators();
      this.createProjectForm.controls["reraId"].clearValidators();
      this.createProjectForm.get('possession').patchValue('');
      this.createProjectForm.get('reraId').patchValue('');
      //this.createProjectForm.controls["uploadBrochure"].setValidators([Validators.required]);
    } else if (event.value == 'Under Construction') {
      this.isShowRera = true;
      this.isShowBrochure = true;
      this.createProjectForm.controls["possession"].setValidators([Validators.required]);
      this.createProjectForm.controls["reraId"].setValidators([Validators.required]);
      this.createProjectForm.get('possession').patchValue('');
      this.createProjectForm.get('reraId').patchValue('');
      //this.createProjectForm.controls["uploadBrochure"].clearValidators();
    } else if (event.value == 'Pre Launch') {
      this.isShowRera = false;
      this.isShowBrochure = false;
      this.createProjectForm.controls["possession"].clearValidators();
      this.createProjectForm.controls["reraId"].clearValidators();
      this.createProjectForm.get('possession').patchValue('');
      this.createProjectForm.get('reraId').patchValue('');
      //this.createProjectForm.controls["uploadBrochure"].clearValidators();
    }
    this.createProjectForm.controls["possession"].updateValueAndValidity();
    this.createProjectForm.controls["reraId"].updateValueAndValidity();
    //this.createProjectForm.controls["uploadBrochure"].updateValueAndValidity();
  }

  checkMOD() {
    if (this.isAurumMODChecked || this.isSheetMODChecked || this.isCRMMODChecked || this.isOtherMODChecked) {
      this.isMODChecked = true
    } else {
      this.isMODChecked = false
    }
  }

  checkIndMOD(event: any, type: any) {

        if (type == 'automate-leads') {
            event.target.checked ? this.isAurumMODChecked = true : this.isAurumMODChecked = false;
            if ((this.userInfo.org_admin && this.userInfo.member_type == 'Vendor') || this.userInfo.role=='SalesAdmin') {
                //this.createProjectForm.get('modAurum').patchValue(true);
                this.createProjectForm.get('modCRM').patchValue(false)
                this.createProjectForm.get('modSheet').patchValue(false);
                this.createProjectForm.get('modOther').patchValue(false);
            }
        }

        if (type == 'google-sheet') {
            event.target.checked ? this.isSheetMODChecked = true : this.isSheetMODChecked = false;
            if ((this.userInfo.org_admin && this.userInfo.member_type == 'Vendor') || this.userInfo.role=='SalesAdmin') {
            this.createProjectForm.get('modAurum').patchValue(false);
            this.createProjectForm.get('modCRM').patchValue(false);
            //this.createProjectForm.get('modSheet').patchValue(true);
            this.createProjectForm.get('modOther').patchValue(false);
            }
        }

        if (type == 'crm') {
            event.target.checked ? this.isCRMMODChecked = true : this.isCRMMODChecked = false;
            if ((this.userInfo.org_admin && this.userInfo.member_type == 'Vendor') || this.userInfo.role=='SalesAdmin') {
            this.createProjectForm.get('modAurum').patchValue(false);
            //this.createProjectForm.get('modCRM').patchValue(true);
            this.createProjectForm.get('modSheet').patchValue(false);
            this.createProjectForm.get('modOther').patchValue(false);
            }
        }

        if (type == 'other') {
            event.target.checked ? this.isOtherMODChecked = true : this.isOtherMODChecked = false;
            if ((this.userInfo.org_admin && this.userInfo.member_type == 'Vendor') || this.userInfo.role=='SalesAdmin') {
            this.createProjectForm.get('modAurum').patchValue(false);
            this.createProjectForm.get('modCRM').patchValue(false);
            this.createProjectForm.get('modSheet').patchValue(false);
            //this.createProjectForm.get('modOther').patchValue(true);
            }
        }

        this.checkMOD()

    }


  checkNotification() {
    if (this.isMailChecked || this.isSMSChecked) {
      this.isNotificationChecked = true
    } else {
      this.isNotificationChecked = false
    }
  }

  checkIndNotification(event: any, type: any) {

    if (type == 'mail') {
      event.target.checked ? this.isMailChecked = true : this.isMailChecked = false
    }

    if (type == 'sms') {
      event.target.checked ? this.isSMSChecked = true : this.isSMSChecked = false
    }

    this.checkNotification()

  }

  selectFile(event: any, uploadSectionType: string): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
  
    const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
    const newFiles = Array.from(input.files);
  
    // Combine all existing files: uploaded + to-be-uploaded
    const allExistingFiles = [
      ...(this.data.brochure || []),
      ...(this.brochureTobeUpload || []),
      ...(this.data.creative_attachment || []),
      ...(this.creativeTobeUpload || []),
      ...(this.data.media_plan_attachment || []),
      ...(this.mediaPlanTobeUpload || [])
    ];
  
    // Calculate total size: existing + new
    const existingSize = allExistingFiles.reduce((acc, file) => acc + this.getFileSize(file), 0);
    const newSize = newFiles.reduce((acc, file) => acc + file.size, 0);
  
    if (existingSize + newSize > MAX_TOTAL_SIZE) {
      this.clipBoardService.showMessgeInText(
        `Combined file size for brochures, creatives, and media plans cannot exceed 100MB.`,
        'error-snackbar'
      );
      input.value = '';
      return;
    }
  
    // Append new files to respective to-be-uploaded list
    newFiles.forEach(file => {
      file['ext'] = file.name.split('.').pop();
      switch (uploadSectionType) {
        case 'brochure':
          this.brochureTobeUpload.push(file);
          this.createProjectForm.controls['uploadBrochure'].reset();
          break;
        case 'creative':
          this.creativeTobeUpload.push(file);
          this.createProjectForm.controls['uploadCreativesOpenFiles'].reset();
          break;
        case 'media-plan':
          this.mediaPlanTobeUpload.push(file);
          this.createProjectForm.controls['uploadMediaPlan'].reset();
          break;
      }
    });
  
    input.value = '';
  }
  
  getFileSize(file: any): number {
    if (file instanceof File) {
      return file.size;
    } else if (file.byte_size) {
      return file.byte_size;
    } else if (file.size && typeof file.size === 'string') {
      return parseInt(file.size, 10);
    }
    return 0;
  }
  

  removeBrochureFile(element) {

    if (element.id == undefined) {
      for (let i = 0; i < this.brochureTobeUpload.length; i++) {
        if (element == this.brochureTobeUpload[i]) {
          this.brochureTobeUpload.splice(i, 1);
          this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
        }
      }
    } else {
      let body = {
        "attachment_id": element.id,
        "campaign_id": this.data.id,
      }
      this.serverService.deleteSaleCampaignBrochureFiles(body, this.authToken).subscribe(data => {
        for (let i = 0; i < this.brochureTobeUpload.length; i++) {
          if (element == this.brochureTobeUpload[i]) {
            this.brochureTobeUpload.splice(i, 1);
          }
        }
        this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
      }, err => {
        this.clipBoardService.checkServerError(err, this.authToken)
      }
      )
    }
  }

  removeCreativeFile(element) {

    if (element.id == undefined) {
      for (let i = 0; i < this.creativeTobeUpload.length; i++) {
        if (element == this.creativeTobeUpload[i]) {
          this.creativeTobeUpload.splice(i, 1);
          this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
        }
      }
    } else {
      let body = {
        "attachment_id": element.id,
        "campaign_id": this.data.id,
      }
      this.serverService.deleteSaleCampaignCreativeFiles(body, this.authToken).subscribe(data => {
        for (let i = 0; i < this.creativeTobeUpload.length; i++) {
          if (element == this.creativeTobeUpload[i]) {
            this.creativeTobeUpload.splice(i, 1);
          }
        }
        this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
      }, err => {
        this.clipBoardService.checkServerError(err, this.authToken)
      }
      )
    }
  }

  removeMediaPlanFile(element) {

    if (element.id == undefined) {
      for (let i = 0; i < this.mediaPlanTobeUpload.length; i++) {
        if (element == this.mediaPlanTobeUpload[i]) {
          this.mediaPlanTobeUpload.splice(i, 1);
          this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
        }
      }
    } else {
      let body = {
        "attachment_id": element.id,
        "campaign_id": this.data.id,
      }
      this.serverService.deleteSaleCampaignMediaPlanFiles(body, this.authToken).subscribe(data => {
        for (let i = 0; i < this.mediaPlanTobeUpload.length; i++) {
          if (element == this.mediaPlanTobeUpload[i]) {
            this.mediaPlanTobeUpload.splice(i, 1);
          }
        }
        this.clipBoardService.showMessgeInText('Successfully Delete', 'success-snackbar')
      }, err => {
        this.clipBoardService.checkServerError(err, this.authToken)
      }
      )
    }
  }



  save(saveType: any) {

    this.isSubmit = true;

    if (saveType == 'isNotBrochure') {
      if (this.createProjectForm.invalid) {
        return false
      }
      if (this.mediaPlanTobeUpload.length == 0) {
        return false
      }
      if (!this.isMODChecked) {
        return false
      }
    }

    else if (saveType == 'isBrochure') {
      if (this.createProjectForm.invalid) {
        return false
      }
      if (this.mediaPlanTobeUpload.length == 0) {
        return false
      }
      if (!this.isMODChecked) {
        return false
      }
      if (this.brochureTobeUpload.length == 0) {
        return false
      }
    }

    this.showComponentLoader = true

    //let mod = this.createProjectForm.value.modAurum + ',' + this.createProjectForm.value.modSheet + ',' + this.createProjectForm.value.modCRM + ',' + this.createProjectForm.value.modOther;
    let mod: any = [];


    if (this.createProjectForm.value.modAurum) {
      mod.push('Automate Leads')
    }

    if (this.createProjectForm.value.modCRM) {
      mod.push('CRM')
    }

    if (this.createProjectForm.value.modSheet) {
      mod.push('Google Sheet')
    }

    if (this.createProjectForm.value.modOther) {
      mod.push('Other')
    }

    //let noti: any = this.createProjectForm.value.mailNotification + ',' + this.createProjectForm.value.smsNotification
    let noti: any = []

    if (this.createProjectForm.value.mailNotification) {
      noti.push('Email')
    }

    if (this.createProjectForm.value.smsNotification) {
      noti.push('SMS')
    }
    let tempMSP = ""
    if(this.createProjectForm.value.msp){
     tempMSP = this.createProjectForm.value.msp.join(',');
    }
    const formData: FormData = new FormData();
    formData.append('assigned_sales_user_id', tempMSP)
    formData.append('sales_manager_id', this.createProjectForm.value.sp);
    formData.append('sales_city', this.createProjectForm.value.st);
    formData.append('account_manager_id', this.createProjectForm.value.am);
    formData.append('client_type', this.createProjectForm.value.clientType);

    formData.append('client_name', this.createProjectForm.value.clientName);
    formData.append('client_number', this.createProjectForm.value.clientMobileNumber);
    formData.append('client_email', this.createProjectForm.value.clientEmail);
    formData.append('city', this.createProjectForm.value.city);
    formData.append('client_rera', this.createProjectForm.value.clientRera);
    formData.append('account_type', this.createProjectForm.value.accountType);

    //   if (this.isSuperAdmin) {
    //     formData.append('vendor_id', this.createProjectForm.value.vendor);
    // }

    formData.append('estimated_invoice_id', this.createProjectForm.value.invoiceEstimateId);
    formData.append('deal_type', this.createProjectForm.value.dealType);
    ;

    this.createProjectForm.value.typology = this.createProjectForm.value.typology.filter(function (item) {
      return !(item.typologyConfiguration === '' && item.typologyPrice === '');
    });

    formData.append('topology', JSON.stringify(this.createProjectForm.value.typology));


    formData.append('project_name', this.createProjectForm.value.projectName);
    formData.append('project_type', this.createProjectForm.value.projectType);
    formData.append('project_address', this.createProjectForm.value.location);
    formData.append('latitude', this.createProjectForm.value.latitude);
    formData.append('longitude', this.createProjectForm.value.longitude);

    formData.append('min_price', this.createProjectForm.value.minPrice);
    formData.append('max_price', this.createProjectForm.value.maxPrice);
    formData.append('project_configuration', this.createProjectForm.value.configuration);
    formData.append('project_status', this.createProjectForm.value.projectStatus);

    if (this.brochureTobeUpload != undefined && this.brochureTobeUpload.length != 0) {
      for (var x = 0; x < this.brochureTobeUpload.length; x++) {
        if (this.brochureTobeUpload[x].id == undefined) {
          formData.append("brochure[]", this.brochureTobeUpload[x]);
        }
      }
    }

    formData.append('possession', this.createProjectForm.value.possession);
    formData.append('rera_number', this.createProjectForm.value.reraId);

    formData.append('campaign_type', this.createProjectForm.value.campaignType);
    formData.append('duration', this.createProjectForm.value.duration);
    formData.append('no_of_leads', this.createProjectForm.value.noOfLeads);
    formData.append('min_committed_qualification', this.createProjectForm.value.minQua);
    formData.append('max_committed_qualification', this.createProjectForm.value.maxQua);

    //formData.append('mode_of_delivery', mod);
    formData.append('mode_of_delivery', JSON.stringify(mod));
    //formData.append('mode_of_notification', noti);
    formData.append('mode_of_notification', JSON.stringify(noti));

    formData.append('offers', this.createProjectForm.value.offers);

    formData.append('media_plan[]', this.createProjectForm.value.creativeLink);
    // this.createProjectForm.value.creativeLink.forEach((item) => {
    //   formData.append('media_plan[]', item)
    // })

    if (this.creativeTobeUpload != undefined && this.creativeTobeUpload.length != 0) {
      for (var x = 0; x < this.creativeTobeUpload.length; x++) {
        if (this.creativeTobeUpload[x].id == undefined) {
          formData.append("creative_attachment[]", this.creativeTobeUpload[x]);
        }
      }
    }

    if (this.mediaPlanTobeUpload != undefined && this.mediaPlanTobeUpload.length != 0) {
      for (var x = 0; x < this.mediaPlanTobeUpload.length; x++) {
        if (this.mediaPlanTobeUpload[x].id == undefined) {
          formData.append("media_plan_attachment[]", this.mediaPlanTobeUpload[x]);
        }
      }
    }

    this.btnStatus = true
    this.serverService.editSaleCampaign(this.data.id, formData, this.authToken).subscribe(data => {
      // console.log(data);
      this.btnStatus = false
      this.showComponentLoader = false
      this.clipBoardService.showMessgeInText('Campaign Update Successfully', 'success-snackbar')
      this.dialogRef.close(data)
    }, err => {
      this.btnStatus = false
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  close() {
    this.dialogRef.close();
  }

  addEmails() {
    if (this.createProjectForm.value.email.trim() != '') {
      if (!this.validateEmail(this.createProjectForm.value.email.trim())) {
        this.clipBoardService.showMessgeInText("Email Not valid", "error-snackbar")
        return;
      }
      this.emails.push(this.createProjectForm.value.email)
      this.createProjectForm.controls['email'].setValue('');
    }
  }

  removeEmails(email): void {
    const index = this.emails.indexOf(email);
    if (index > -1) {
      this.emails.splice(index, 1);
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  //
  setDeliveryDate() {
    // console.log("day set")
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + this.createProjectForm.value.campaign_days);
    this.createProjectForm.value.project_delivery_date = currentDate;
    this.project_delivery_date = this.datePipe.transform(this.createProjectForm.value.project_delivery_date, 'yyyy-MM-dd') || '';
    // console.log(this.project_delivey_date)
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
        ? 'Vendor Standard User'
        : item.role;
  }
  resetLatLng(){
   this.latitude = '';
   this.longitude = '';
   this.createProjectForm.get('latitude').patchValue(this.latitude)
   this.createProjectForm.get('longitude').patchValue(this.longitude)
  }
  removeSpaces(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/\s+/g, ''); // Remove all spaces
    this.createProjectForm.controls['clientMobileNumber'].setValue(inputElement.value); // Update the form control value
  }

  valueInWords(value, type) {

    let values = Number(value)

    if (type == 'minValue') {

        this.minValuesWithCommaSystem = values.toLocaleString('en-IN');

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        this.minValuesWithComma = value;
        if ((this.minValuesWithComma = this.minValuesWithComma.toString()).length > 9) return 'overflow';
        this.minValuesWithComma = ('000000000' + this.minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!this.minValuesWithComma) return; var str = '';
        str += (this.minValuesWithComma[1] != 0) ? (a[Number(this.minValuesWithComma[1])] || b[this.minValuesWithComma[1][0]] + ' ' + a[this.minValuesWithComma[1][1]]) + 'crore ' : '';
        str += (this.minValuesWithComma[2] != 0) ? (a[Number(this.minValuesWithComma[2])] || b[this.minValuesWithComma[2][0]] + ' ' + a[this.minValuesWithComma[2][1]]) + 'lakh ' : '';
        str += (this.minValuesWithComma[3] != 0) ? (a[Number(this.minValuesWithComma[3])] || b[this.minValuesWithComma[3][0]] + ' ' + a[this.minValuesWithComma[3][1]]) + 'thousand ' : '';
        str += (this.minValuesWithComma[4] != 0) ? (a[Number(this.minValuesWithComma[4])] || b[this.minValuesWithComma[4][0]] + ' ' + a[this.minValuesWithComma[4][1]]) + 'hundred ' : '';
        str += (this.minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(this.minValuesWithComma[5])] || b[this.minValuesWithComma[5][0]] + ' ' + a[this.minValuesWithComma[5][1]]) + 'only ' : '';
        this.minNumInWords = str;          
    }

    if (type == 'maxValue') {

        this.maxValuesWithCommaSystem = values.toLocaleString('en-IN');

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        this.maxValuesWithComma = value;
        if ((this.maxValuesWithComma = this.maxValuesWithComma.toString()).length > 9) return 'overflow';
        this.maxValuesWithComma = ('000000000' + this.maxValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!this.maxValuesWithComma) return; var str = '';
        str += (this.maxValuesWithComma[1] != 0) ? (a[Number(this.maxValuesWithComma[1])] || b[this.maxValuesWithComma[1][0]] + ' ' + a[this.maxValuesWithComma[1][1]]) + 'crore ' : '';
        str += (this.maxValuesWithComma[2] != 0) ? (a[Number(this.maxValuesWithComma[2])] || b[this.maxValuesWithComma[2][0]] + ' ' + a[this.maxValuesWithComma[2][1]]) + 'lakh ' : '';
        str += (this.maxValuesWithComma[3] != 0) ? (a[Number(this.maxValuesWithComma[3])] || b[this.maxValuesWithComma[3][0]] + ' ' + a[this.maxValuesWithComma[3][1]]) + 'thousand ' : '';
        str += (this.maxValuesWithComma[4] != 0) ? (a[Number(this.maxValuesWithComma[4])] || b[this.maxValuesWithComma[4][0]] + ' ' + a[this.maxValuesWithComma[4][1]]) + 'hundred ' : '';
        str += (this.maxValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(this.maxValuesWithComma[5])] || b[this.maxValuesWithComma[5][0]] + ' ' + a[this.maxValuesWithComma[5][1]]) + 'only ' : '';
        this.maxNumInWords = str;
    }

}

}